<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="preface"><a id="page_xi"></a><strong>Preface</strong></h2>
<p class="noindent">Many people have helped me in different ways during the writing of this book. I thank the numerous individuals who commented on various parts of the manuscript: Richard Delgado, Daniel Farber, John Garvey, Gary Minda, Mark Tushnet, Tom Wartenberg, Larry Backer, Morris Bernstein, Bill Hollingsworth, Lundy Langston, Maria Mansfield, Nick Rostow, Mark Brauner, Laura Feldman, and Virginia Lockman. I appreciate also the comments received from the participants at the 1994 Mid-South Philosophy Conference, where I presented some of my ideas on the postmodern concept of power. I especially thank Richard Delgado, Jean Stefancic, and Niko Pfund for including this project in the Critical America series from New York University Press. The financial support of the Faculty Summer Research Grant Program of the University of Tulsa College of Law helped create the time needed to work on the book. The librarians at the University of Tulsa College of Law—particularly Nanette Hjelm, Carol Arnold, and Rich Ducey—helped me enormously in obtaining resources needed for research. Finally, I thank my family, Laura, Mollie, and Samuel, for always being so wonderful, loving, and supportive.</p>
<p class="indent">An earlier version of <span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample">chapter 10</span> appeared in the Iowa Law Review.<a id="page_xii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface.vue?46e45ba4